import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.row-invalid {
  position: relative;
  border: 1px solid ${dt('form.field.invalid.border.color')} !important;
  border-radius: ${dt('content.border.radius')};
  background: ${dt('form.field.invalid.background')};
}

.row-border + .row-invalid {
  margin-top: -1px;
}

.row-invalid::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 3px;
  background: ${dt('form.field.invalid.border.color')};
  border-top-left-radius: ${dt('content.border.radius')};
  border-bottom-left-radius: ${dt('content.border.radius')};
}`;
